export class Filter {
    public selected: boolean;
    public term: string;
    public sala: string;
    public horario: string;
    public hasVagas: boolean;
    public tipo: string;
    public palestrante: string;
}


// WEBPACK FOOTER //
// ./src/models/filter.model.ts